import { A } from '@solidjs/router';
import { For, Show } from 'solid-js';
import { dismiss, toasts } from '../lib/toasts';
import { IconClose } from './Icons';

export function Toasts() {
  return (
    <div class="toasts" role="status" aria-live="polite">
      <For each={toasts()}>
        {(t) => (
          <div class={`toast ${t.tone}`}>
            <span>{t.message}</span>
            <Show when={t.action}>
              <Show when={t.action!.href} fallback={<button class="link" onClick={() => { t.action!.run?.(); dismiss(t.id); }}>{t.action!.label}</button>}>
                <A class="link" href={t.action!.href!} onClick={() => dismiss(t.id)}>
                  {t.action!.label}
                </A>
              </Show>
            </Show>
            <button class="icon-btn" onClick={() => dismiss(t.id)} aria-label="Dismiss">
              <IconClose />
            </button>
          </div>
        )}
      </For>
    </div>
  );
}
